import { ProgrammeCard } from '../../components/sections/Programme/components';

export default function ProgrammeController(conference) {

    const tabs = document.querySelectorAll('.programme-day-tab');
    const content = document.querySelector('.programme-content');

    if (!tabs.length || !content || !conference?.programme?.length) {
        return;
    }

    const settings = conference.settings?.programme ?? {};

    const options = {
        showDayLabel: settings.showDayLabel ?? true,
        showFullDate: settings.showFullDate ?? true,
        showTimes: settings.showTimes ?? true,
        showSpeakers: settings.showSpeakers ?? true,
        showAffiliations: settings.showAffiliations ?? true,
        showLocations: settings.showLocations ?? true,
        showDescriptions: settings.showDescriptions ?? true,
    };

    tabs.forEach(tab => {

        tab.addEventListener('click', () => {

            const dayId = Number(tab.dataset.programmeDay);

            const day = conference.programme.find(
                item => Number(item.id) === dayId
            );

            if (!day) {
                return;
            }

            tabs.forEach(item => {
                item.classList.toggle(
                    'programme-day-tab--active',
                    item === tab
                );
            });

            content.innerHTML = ProgrammeCard(day, options);

        });

    });

}
